import styled from 'styled-components'

type Props = {
	isDisabled: boolean
	isFocused: boolean
	hasContent: boolean
	hasError: boolean
}

export const Label = styled.label<Props>`
	display: block;
	position: relative;
	cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'text')};
	font-size: 16px;
	padding: 0 4px;
	margin: 0 14px;
	background-color: ${({ theme }) => theme.color.input.background};
	transform: ${({ isFocused, hasContent }) => (isFocused || hasContent ? `translateY(6px) scale(${3 / 4})` : 'translateY(40px)')};
	transform-origin: bottom left;
	z-index: 1;
	transition: color 0.2s, transform 0.2s, font-size 0.2s;
	width: fit-content;
	max-width: calc(75% - 12px);
	text-align: left;
	color: ${({ hasError, isFocused, theme }) => {
		if (hasError) {
			return theme.color.input.borderError
		}
		if (isFocused) {
			return theme.color.input.borderHover
		}
		return theme.color.input.label
	}};
`
